import 'moment/locale/it';
const it = {};
export default it;
